import axios from "axios";
import { api } from "../config";
import { fetchAuthSession, signOut } from "aws-amplify/auth";

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// content type
const token = localStorage.getItem("token");

if(token)
axios.defaults.headers.common["Authorization"] = "Bearer " + token;

// intercepting to capture errors
// axios.interceptors.response.use(
//   function (response) {
//     return response.data ? response.data : response;
//   },
//   function (error) {
    
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     let message;
//     switch (error.status) {
//       case 500:
//         message = error.response.data.message || "Internal Server Error";
//         break;
//       case 401:
//         message = error.response.data.message|| "Invalid credentials";
//         break;
//       case 404:
//         message =error.response.data.message || "Sorry! the data you are looking for could not be found";
//         break;
//       default:
//         message = error.response.data || error;
//     }
  

    
//     return Promise.reject(message);
//   }
// );
const refreshToken = async () => {
  try {
    const session = await fetchAuthSession();    
    const newToken = session.tokens.idToken ? session.tokens.idToken : ""
    localStorage.setItem("token", newToken);
    setAuthorization(newToken);
    return newToken;
  } catch (error) {
    console.error("Error refreshing token:", error);
    await signOut();
    window.location.reload();
    throw error;
  }
};
 
// Axios response interceptor for handling token expiration
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  async function (error) {
    const errorData = error?.response?.data;
    let message;
    if (error.response?.status == 401 && errorData?.message == "The incoming token has expired") {
      try {
        const newToken = await refreshToken();
        error.config.headers["Authorization"] = "Bearer " + newToken;
        return axios.request(error.config); // Retry the original request with new token
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }
 
    switch (error.response?.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      case 404:
        message = errorData?.message || "Sorry! the data you are looking for could not be found";
        break;
      case 400:
        message = errorData?.message || "Bad Request";
        break;
      default:
        message = error.message || error;
    }
    return Promise.reject({ message, errorData });
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

const useAPIClient = () => {
  const get = (url, params) => {
    let response;
    let paramKeys = [];
    if (params) {
      Object.keys(params).forEach(key => {
        paramKeys.push(key + '=' + params[key]);
      });

      const queryString = paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`);
    } else {
      response = axios.get(url);
    }
    return response;
  };
 
  const create = (url, data) => {
    return axios.post(url, data);
  };

  const update = (url, data) => {
    return axios.patch(url, data);
  };

  const patch = (url, data) => {
    return axios.patch(url, data);
  };

  const put = (url, data) => {
    return axios.put(url, data);
  };

  const deleteRequest = (url, data) => {
    return axios.delete(url, {data});
  };



  return { get, create, update, put, delete: deleteRequest, patch};
};
const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { useAPIClient, setAuthorization, getLoggedinUser };